import { ReactNode, useMemo } from 'react';

import { Tooltip } from '@/design-system';
import CopyIcon from '@/icons/CopyIcon.svg?react';
import { cn } from '@/utils/tailwind';

import { useCopy } from './CopyButton/useCopy';

export const CopyInlineLink = (props: {
  value: string | null | undefined;
  truncate?: number;
  children?: ReactNode;
  className?: string;
  prefix?: string;
  icon?: ReactNode;
  placement?: 'top' | 'bottom';
  disableDefaultClasses?: boolean;
  showValuePreview?: boolean;
  hideIcon?: boolean;
}) => {
  const showValuePreview = props.showValuePreview ?? true;
  const { copied, onCopy } = useCopy({ copy: props.value ?? '' });
  const truncatedValue = useMemo(
    () =>
      props.truncate != null
        ? `${props.value?.slice(0, props.truncate)}...`
        : props.value,
    [props.value, props.truncate]
  );
  return (
    <Tooltip
      title={
        <div className="flex flex-col items-start">
          {truncatedValue && (
            <span>
              {props.prefix || 'ID'}
              {showValuePreview && (
                <>
                  : <span className="font-mono">{truncatedValue}</span>
                </>
              )}
            </span>
          )}
          <span className="opacity-70">
            {copied ? 'Copied!' : 'Click to copy'}
          </span>
        </div>
      }
      side={props.placement || 'top'}
      blockTriggerEvents
    >
      <div
        onClick={(e) => {
          e.preventDefault();
          onCopy();
        }}
        className={cn(
          !props.disableDefaultClasses &&
            'flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm',
          props.className
        )}
      >
        {!props.hideIcon && (props.icon ?? <CopyIcon className="h-4 w-4" />)}
        {props.children}
      </div>
    </Tooltip>
  );
};
